export const getDefaultValues = (bannerDetails) => ({
  NotificationBannerTitle: bannerDetails?.NotificationBannerTitle || '',
  NotificationBannerTitlePanel: bannerDetails?.NotificationBannerTitlePanel || '',
  NotificationBannerValue: bannerDetails?.NotificationBannerValue || '',
  NotificationBannerLink: bannerDetails?.NotificationBannerLink || '',
  NotificationBannerTextLink: bannerDetails?.NotificationBannerTextLink || '',
  NotificationBannerDateStart: bannerDetails?.NotificationBannerDateStart || '',
  NotificationBannerDateExpire: bannerDetails?.NotificationBannerDateExpire || '',
  NotificationBannerTimeStart: bannerDetails?.NotificationBannerTimeStart || '',
  NotificationBannerTimeEnd: bannerDetails?.NotificationBannerTimeEnd || '',
  NotificationBannerLinkMp4: bannerDetails?.NotificationBannerLinkMp4 || '',
  NotificationBannerOrderIndex: bannerDetails?.NotificationBannerOrderIndex || 1,
  NotificationBannerStatus: bannerDetails?.NotificationBannerStatus === 1 ? true : false,
  NotificationBannerShowOnlyForProfile: bannerDetails?.NotificationBannerShowOnlyForProfile
    ? 'نمایش فقط به کاربران عضو شده'
    : 'نمایش عمومی',
});
